import { LFlex, LSubTitle, LTitle } from "@components";
import { faCircleLeft } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "react-i18nify";
import { NavLink } from "react-router-dom";

export const ContactFacilitator = (): JSX.Element => {
    return (
        <>
            <LFlex justifyCenter alignCenter className="p-6">
                <LFlex className="is-justify-content-space-between" row>
                    <LFlex alignCenter justifyCenter>
                        <LTitle color="has-text-dark-blue">{translate("assessments.deviceCheck.support.title")}</LTitle>
                        <LSubTitle size="5" color="has-text-dark-blue" className="mt-3">
                            {translate("assessments.deviceCheck.support.body")}
                        </LSubTitle>
                    </LFlex>
                </LFlex>

                <div className="assessment-back" style={{ position: "absolute", right: "5%", bottom: "5%" }}>
                    <NavLink to="/admin/assessments/assessmentsUpcoming">
                        <FontAwesomeIcon icon={faCircleLeft} size={"xl"} />
                        <span className="subtitle px-2 has-text-primary-blue">
                            {translate("assessments.deviceCheck.support.exitAssessment")}
                        </span>
                    </NavLink>
                </div>
            </LFlex>
        </>
    );
};
